import { useScriptTag } from '@vueuse/core';
import { parseUA, PromiseWithResolvers } from '@os-web/utils';
import { __DEV__, __PROJECT_NAME__, STORAGE_CHANNEL_KEY } from '@os-web/const';
import http from '@os-web/http';
import queryString from 'query-string';

// m.yiqiwen.cn百度统计
const { load } = useScriptTag('https://hm.baidu.com/hm.js?5429dc60e2d634e6ca6570ac3133c551');

// 其他域名的百度统计
const { load: loadCopy } = useScriptTag(
  'https://hm.baidu.com/hm.js?93b2c16336898e48575227b87cab2944',
);

const { promise, resolve } = PromiseWithResolvers();

export class BaiduEvent {
  static debug = false;

  static async getConfig() {
    return await http
      .get('/api/comm/sw_config', {
        url: __DEV__ ? 'https://sandbox-h5.globecul.com' : location.href,
      })
      .catch((e) => {
        console.error('/api/comm/sw_config error: ', e);
      });
  }

  static async init({ debug = false } = {}) {
    this.debug = debug;

    const fromType = (await this.getConfig())?.from;
    // 加载百度埋点sdk
    if (String(fromType) === '2') {
      await loadCopy();
    } else {
      await load();
    }

    resolve();
  }

  /**
   *
   * @param category 要监控的目标的类型名称，通常是同一组目标的名字，比如"视频"、"音乐"、"软件"、"游戏"等等。该项必选。
   * @param action 用户跟目标交互的行为，如"播放"、"暂停"、"下载"等等。该项必选。
   * @param opt_label 事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选。
   * @param opt_value 事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选。
   */
  static async track(category = '', action = '', opt_label = '', opt_value = '') {
    const list = [category, action, opt_label, opt_value];
    if (__DEV__ && this.debug) {
      console.log('百度事件: ', list);
      return;
    }

    await promise;
    if (window._hmt) {
      window._hmt.push(['_trackEvent', ...list]);
    }
  }

  static async routeEach(to) {
    await promise;
    {
      // 补全后面的"/"
      const path = to.path + (to.path.endsWith('/') ? '' : '/');
      const suffix = parseUA().weixin ? 'wx' : 'h5';

      const url = queryString.stringifyUrl(
        {
          url: `/${__PROJECT_NAME__}${path}${suffix}`,
          query: {
            channel: localStorage.getItem(STORAGE_CHANNEL_KEY),
          },
        },
        {
          skipNull: true,
        },
      );

      if (window._hmt) {
        window._hmt.push(['_trackPageview', url]);
      }
    }
  }
}
